var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5835 7.5773C7.8585 9.3078 6.1725 10.9963 4.5255 12.6428C4.43929 12.7334 4.39121 12.8537 4.39121 12.9788C4.39121 13.1039 4.43929 13.2242 4.5255 13.3148C4.75875 13.5743 5.12775 13.5518 5.29575 13.3748C7.00275 11.6633 8.7885 9.87455 10.653 8.00855C10.801 7.88705 10.875 7.74355 10.875 7.57805C10.875 7.41255 10.801 7.26455 10.653 7.13405L5.04075 1.65455C4.93301 1.55569 4.79101 1.50268 4.64484 1.50674C4.49868 1.5108 4.35984 1.57161 4.25775 1.6763C3.98925 1.94555 4.09275 2.21105 4.21425 2.33705C6.00681 4.08142 7.79682 5.82842 9.58425 7.57805",
    fill: "#F8F8F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/Next.4c79652f8131241427ac60c40d37dc1f.svg";
export { ForwardRef as ReactComponent };